// extracted by mini-css-extract-plugin
export default {"buttons":"buttons__B9ERI"};